import { render, staticRenderFns } from "./zhengzhuangqunfenxi.vue?vue&type=template&id=60f75f6e&"
import script from "./zhengzhuangqunfenxi.vue?vue&type=script&lang=ts&"
export * from "./zhengzhuangqunfenxi.vue?vue&type=script&lang=ts&"
import style0 from "./zhengzhuangqunfenxi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports